module.exports = __webpack_public_path__ + "static/media/1.question.1f53a2d7.mp4";